import React from "react";
import { FaEnvelope, FaPhone, FaMapMarkerAlt } from "react-icons/fa";

function Footer() {
  return (
    <footer
      className="text-light border-top w-100"
      style={{
        backgroundColor: "#002b80",
        overflowX: "hidden", //  prevent micro overflow
      }}
    >
      {/* FULL WIDTH STRIP */}
      <div className="container-fluid px-3 px-md-5 py-4">
        <div className="row g-4">
          {/* Company Info */}
          <div className="col-12 col-md-6">
            <h5 className="fw-bold mb-3">Afrogebeya Technologies</h5>

            <p className="mb-2 d-flex align-items-start">
              <FaMapMarkerAlt className="me-2 mt-1" />
              <span>
                Addis Ababa, Nifas Silk Lafto <br className="d-md-none" />
                Wereda 7
              </span>
            </p>

            <p className="mb-2 d-flex align-items-center">
              <FaEnvelope className="me-2" />
              <a
                href="mailto:info@afrogebeya.com"
                className="text-light text-decoration-none"
              >
                info@afrogebeya.com
              </a>
            </p>

            <p className="mb-0 d-flex align-items-center">
              <FaPhone className="me-2" />
              <a
                href="tel:+251909999988"
                className="text-light text-decoration-none"
              >
                +251909999988
              </a>
            </p>
          </div>

          {/* Legal */}
          <div className="col-12 col-md-6">
            <h5 className="fw-bold mb-3">Legal</h5>
            <ul className="list-unstyled mb-0">
              <li className="mb-2">
                <a href="/terms" className="text-light text-decoration-none">
                  Terms & Conditions
                </a>
              </li>
              <li className="mb-2">
                <a href="/terms" className="text-light text-decoration-none">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="/terms" className="text-light text-decoration-none">
                  Cookie Policy
                </a>
              </li>
            </ul>
          </div>
        </div>
        {/* Bottom */}
        <div className="text-center small border-light pt-3 mt-4">
          © 2017-{new Date().getFullYear()} Afrogebeya Technologies. All rights
          reserved.{" "}
        </div>{" "}
      </div>
    </footer>
  );
}

export default Footer;
